<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2" >
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" offset="2">
                    <span>小程序连接</span>
                </el-col>
                <el-col :span="16" >
                    <el-form  :model="formInline"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="">
                            <el-input v-model="formInline.miniPath"  placeholder="小程序连接"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                </el-col>
            </el-row>
        </div>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="distributorName" label="分销员" width="150"></el-table-column>
            <el-table-column prop="link" label="分销连接"  >
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="150">
                <template slot-scope="scope">
                    <el-button type="success" v-show="scope.row.link!=null&&scope.row.link!=''" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :path="this.miniPath" ></Preview>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getDistributorLinkVoList
    } from '../../api/api';
    import Preview from "../../components/PreviewByPath.vue";
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                loading: false,
                showPreviewDialog: false,
                formInline: {
                    miniPath: 'pages/home/index',
                    currentPage: 1,
                    pageSize: 50,
                    recordsTotal: 0,
                },
            }
        },
        computed: {
        },
        //挂载时候执行
        mounted(){
        },
        components: {
            Preview
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading=true
                getDistributorLinkVoList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.listData = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handlePreActive(row){
                this.miniPath = row.link;
                this.schemeName=row.distributorName+'分销连接'
                this.showPreviewDialog = true;
            },
            returnHistory(){
                window.history.back()
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/distribution/distributorLink.vue